/**
 * Woran man einem Rechtstext ansieht, dass er noch nicht fertig ist.
 *
 * Zwei Formen, weil es zwei gibt: `AUSFÜLLEN` als ausgeschriebene Marke, und `{{…}}` aus den
 * Vorlagen, mit denen Datenschutz und Mietvertrag angelegt wurden. Nur auf die erste zu prüfen war
 * mein Fehler — die zweite stand längst im Portal und zeigte dem Gast wörtlich
 * „{{Firmenname}}" und „{{Zuständige Aufsichtsbehörde mit Anschrift}}".
 */
export const LEGAL_PLACEHOLDER = /AUSFÜLLEN|\{\{[^}]+\}\}/;
